import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Stack, Box, Switch, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { SettingsBox } from '../Data'
import { DATA_SECURITY_LINK } from 'src/Configuration/addresses'

const useStyles = makeStyles()(theme => ({
  cookieLink: {
    color: theme.palette.primary.main,
  },
  description: {
    marginBottom: theme.spacing(4),
  },
}))

interface Props {
  essentialsCookie: boolean
  googleMapsCookie: boolean
  setGoogleMapsCookie: (value: boolean) => void
}

/**
 *  Component to manage cookies
 */
const CookieForm: React.FC<Props> = ({ essentialsCookie, googleMapsCookie, setGoogleMapsCookie }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  return (
    <Stack>
      <Box gap={2} className={classes.description}>
        <Typography variant="body2">
          {t('cookies.message')}
          <Box component="a" href={DATA_SECURITY_LINK} target="_blank" rel="noreferrer" className={classes.cookieLink}>
            {t('cookies.linkDescription')}
          </Box>
        </Typography>
        <Typography variant="body2">{t('cookies.hint')}</Typography>
      </Box>
      <SettingsBox title={t('cookies.essentials')} suffix={<Switch disabled checked={essentialsCookie} />} isSingleLine />
      <SettingsBox
        title={t('cookies.googleMaps')}
        suffix={<Switch checked={googleMapsCookie} onChange={event => setGoogleMapsCookie(event.target.checked)} />}
        isSingleLine
        description={t('cookies.google-maps-description')}
      />
    </Stack>
  )
}

export default CookieForm
